import { Checkbox } from '@e2n/ui';
import { Markierung } from '@/domain/termine/components/Markierung/Markierung';
import { markierungMapper } from '@/domain/termine/shared/types';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';

type CalendarSelectCommandItemValuesProps = {
  kalenderItem: TerminKalender;
  selectedKalenderIds: string[];
};

export function CalendarSelectCommandItemValues({
  kalenderItem,
  selectedKalenderIds,
}: CalendarSelectCommandItemValuesProps) {
  return (
    <div className="flex justify-between items-center w-full">
      <div className="flex items-center gap-2">
        {kalenderItem.markierung && kalenderItem.id !== 'NO_KALENDER' && (
          <Markierung color={markierungMapper[kalenderItem.markierung].base} />
        )}
        <span>{kalenderItem.name}</span>
      </div>
      <Checkbox checked={selectedKalenderIds.includes(kalenderItem.id)} />
    </div>
  );
}
